"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOtherErrorsTrads = void 0;
exports.EOtherErrorsTrads = {
    revenuCharge_error: "Veuillez indiquer le montant et la nature de la charge.",
};
